import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import NoImg from "../../assets/images/no-image.png";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useSeller } from "../../hooks/useSeller";
import { useToast } from "../../hooks/useToast";

interface Product {
  id: number;
  name: string;
  image: string;
  unitPrice: number;
  promotionalPrice: number;
  quantity: number;
  stock: number;
  sku: string;
  variation: string;
  code: string;
  locationId: number;
  pluginspaceHash: string;
}

type ModalProdutoCarrinhoProps = {
  isOpen: boolean;
  product: Product;
  setIsOpen: (value: boolean) => void;
};

export function ModalProdutoCarrinho({
  isOpen,
  setIsOpen,
  product,
}: ModalProdutoCarrinhoProps) {
  const navigate = useNavigate();
  const { pluginspace } = usePluginspace();
  const { pluginspace_id } = useParams();
  const { getAppConfig } = useAppConfig();
  const { getTokenSeller } = useSeller();
  const [isSeller, setIsSeller] = useState(false);
  const [config, setConfig] = useState<ConfigType>();

  const [hasLogin, setHasLogin] = useState<boolean>(true);
  const [isCard, setIsCard] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isLandmark, setIsLandmark] = useState(false);
  const [isCounter, setIsCounter] = useState(false);
  const [isInternalDelivery, setIsInternalDelivery] = useState(false);

  const toastComponent = useToast();

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getCardNumber = () => {
    return localStorage.getItem("card_number");
  };

  const getCounterNumber = () => {
    return localStorage.getItem("counter_number");
  };

  const getTableNumber = () => {
    return localStorage.getItem("table_number");
  };

  const getInternalNumber = () => {
    return localStorage.getItem("internal_number");
  };

  async function loadConfig() {
    const aux = await getAppConfig();
    setConfig(aux!);
    if (getLandmark()) {
      setIsLandmark(true);
    }
    if (getCounterNumber()) {
      setIsCounter(true);
    }
    if (getCardNumber()) {
      setIsCard(true);
    }
    if (getTableNumber()) {
      setIsTable(true);
    }
    if (getInternalNumber()) {
      setIsInternalDelivery(true);
    }
  }

  function setSeller() {
    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      setIsSeller(true);
    }
  }

  const goToCart = () => {
    try {
      // ✅ 1. Verificar comanda (localStorage é a fonte correta)
      const cardNumber = localStorage.getItem("card_number");

      // ✅ 2. Verificar se é template food/retail SEM mesa/comanda/balcão
      const hasTableNumber = getTableNumber();
      const hasCardNumber = getCardNumber(); // localStorage fallback
      const hasLandmark = getLandmark();
      const hasCounterNumber = getCounterNumber();
      const hasInternalNumber = getInternalNumber();

      const isFood = pluginspace?.type === "food";
      const hasAnyFoodMode =
        hasTableNumber ||
        hasCardNumber ||
        hasLandmark ||
        hasCounterNumber ||
        hasInternalNumber;
      const hasAppLogin = pluginspace?.appLogin;

      if (hasAnyFoodMode || cardNumber) {
        navigate(`/${pluginspace_id}/cart-card`);
        return;
      }

      // ✅ 3. Se for retail/ecommerce sem modo food e sem vendedor -> novo carrinho
      if (
        pluginspace &&
        !isFood &&
        !hasAnyFoodMode &&
        !isSeller &&
        hasAppLogin
      ) {
        navigate(`/${pluginspace_id}/new-cart`);
        return;
      }

      // ✅ 4. Todos os outros casos -> carrinho padrão
      // (Vendedor, Food, ou sem login)
      navigate(`/${pluginspace_id}/cart`);
    } catch (error) {
      console.error("Erro ao navegar para carrinho:", error);
      // ✅ 5. Fallback em caso de erro
      try {
        navigate(`/${pluginspace_id}/cart`);
      } catch (fallbackError) {
        console.error("Erro crítico na navegação:", fallbackError);
        // Último recurso: reload com hash
        window.location.href = `/${pluginspace_id}/cart`;
      }
    }
  };

  useEffect(() => {
    setSeller();
    loadConfig();
  }, []);

  function formatarNomeProduto(str: string): string {
    // Dividir a string em palavras usando espaço como delimitador
    const palavras = str.split(" ");

    // Mapear cada palavra e formatá-la
    const palavrasFormatadas = palavras.map((palavra) => {
      // Transformar a primeira letra em maiúscula e as demais em minúscula
      const primeiraLetra = palavra.charAt(0).toUpperCase();
      const restoPalavra = palavra.slice(1).toLowerCase();
      return primeiraLetra + restoPalavra;
    });

    // Juntar as palavras formatadas de volta em uma única string
    return palavrasFormatadas.join(" ");
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-produto-carrinho"
      contentLabel="Produto adicionado ao carrinho"
      overlayClassName="overlay-modal-carrinho"
      ariaHideApp={false}
    >
      <div className="modal-produto-carrinho-content">
        <div className="produtoModalCarrinho">
          <div className="produtoModalInfo" id="infoProduto">
            <span> Produto adicionado ao carrinho</span>
          </div>

          <div className="produtoInformacao">
            <div className="imagem">
              {product?.image ? (
                <img
                  src={product?.image}
                  style={{
                    height: "120px",
                    width: "auto",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                  alt=""
                />
              ) : (
                <img
                  src={NoImg}
                  className="img-carousel"
                  alt="no-image"
                  style={{
                    height: "120px",
                    width: "auto",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>

            <span>
              {formatarNomeProduto(product?.name ? product?.name : "")}
            </span>
          </div>
        </div>

        <div className="buttons-content">
          <button
            className="buyMore"
            style={{
              background: config?.webappcolor.backgroundstatusactive
                ? config.webappcolor.backgroundstatusactive
                : "#EAEAEA",
              color: "#FFF",
            }}
            onClick={() => {
              toastComponent.openToast(
                "success",
                `${product?.name} adicionado ao carrinho`
              );
              navigate(-1);
            }}
          >
            <span>Continuar comprando</span>
          </button>

          <button
            className="finishShop"
            style={{
              border: `solid  ${
                config?.webappcolor.backgroundstatus
                  ? config.webappcolor.backgroundstatus
                  : "#EAEAEA"
              } `,
              borderWidth: "1px",
              color: config?.webappcolor.backgroundstatus
                ? config.webappcolor.backgroundstatus
                : "#EAEAEA",
            }}
            onClick={() => {
              toastComponent.openToast(
                "success",
                `${product?.name} adicionado ao carrinho`
              );
              goToCart();
            }}
          >
            <span>Ir para o carrinho</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
